import Vue from 'vue';
import moment from 'moment';

Vue.filter('time', function (value) {
  return moment(value)
    .format('HH:mm');
});
